import SettingsVerificationSimpleView from './SettingsVerificationSimpleView'
export default SettingsVerificationSimpleView
